import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import {
    TassatLogoAndName as TassatLogoAndNameIcon,
    TassatPayLogoAndName as TassatPayLogoAndNameIcon
} from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { PoweredByProps } from './types';

export const PoweredBy = (props: PoweredByProps) => {
    const {
        isAdmin,
        orientation = 'horizontal',
        tassatOnly = false,
        useTpayLogo
    } = props;

    const theme = useTheme<typeof muiTheme>();
    const classes = muiStyles(props);

    const renderLogo = () => {
        const horizontalGridClass = useTpayLogo ? classes.tassatPayLogoHorizontal : classes.tassatLogoHorizontal;

        return (
            <Grid
                className={orientation === 'vertical' ? classes.logoVertical : horizontalGridClass}
                item
            >
                {
                    useTpayLogo ?
                        <TassatPayLogoAndNameIcon className={classes.rootLogo} />
                        : <TassatLogoAndNameIcon className={classes.rootLogo} />
                }
            </Grid>
        );
    };

    if (tassatOnly || isAdmin ||
        (!theme?.app?.tassat?.poweredBy?.includeClientName && !theme?.app?.tassat?.poweredBy?.includeAppName)) {
        return (
            <Grid
                alignItems={orientation === 'vertical' ? 'flex-start' : 'center'}
                className={orientation === 'vertical' ? classes.margin : ''}
                container
                direction={orientation === 'vertical' ? 'column' : 'row'}
                justifyContent='flex-end'
                spacing={0}
                wrap='nowrap'
            >
                <Grid item>
                    <Typography
                        className={`${classes.text} ${classes.textNoClient}`}
                        variant='body1'
                    >
                        Powered by
                    </Typography>
                </Grid>
                <Grid
                    item
                >
                    {renderLogo()}
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid
            alignItems='flex-end'
            container
            direction='column'
            justifyContent='flex-end'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                className={classes.clientContainers}
                container
                direction='row'
                wrap='nowrap'
            >
                <Grid item>
                    <Typography
                        className={classes.text}
                        variant='body1'
                    >
                        {!isAdmin &&
                            theme?.app?.tassat.poweredBy?.includeClientName &&
                            `${theme?.app?.clientTheme.names.clientName} `}
                        {!isAdmin &&
                            theme?.app?.tassat.poweredBy?.includeAppName &&
                            `${theme?.app?.clientTheme.names.applicationName} `}
                    </Typography>
                </Grid>
            </Grid>
            <Grid
                className={classes.clientContainers}
                container
                direction='row'
                wrap='nowrap'
            >
                <Typography
                    className={`${classes.text} ${classes.textWithClient}`}
                    variant='body1'
                >
                    Powered by
                </Typography>
                <Grid
                    item
                >
                    <Grid
                        className={classes.logoWithClient}
                        item
                    >
                        {
                            useTpayLogo ?
                                <TassatPayLogoAndNameIcon className={classes.rootLogo} />
                                : <TassatLogoAndNameIcon className={classes.rootLogo} />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};